import { render, staticRenderFns } from "./MarketCurrency.vue?vue&type=template&id=7d000f98"
import script from "./MarketCurrency.vue?vue&type=script&lang=js"
export * from "./MarketCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports